var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvesteringWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1028",
    "data-name": "Groupe 1028",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#d4eacd",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-euro-sign",
    "data-name": "Icon awesome-euro-sign",
    d: "M9.522,13.949a.367.367,0,0,0-.442-.287,6.438,6.438,0,0,1-1.392.166A3.945,3.945,0,0,1,3.965,11.21H7.45a.368.368,0,0,0,.359-.287l.2-.869A.368.368,0,0,0,7.645,9.6H3.531a6.616,6.616,0,0,1,0-1.295H8.028a.368.368,0,0,0,.359-.289l.2-.912a.368.368,0,0,0-.359-.446H3.99a3.849,3.849,0,0,1,3.6-2.3,6,6,0,0,1,1.16.127.368.368,0,0,0,.429-.264l.367-1.36a.367.367,0,0,0-.286-.457A8.925,8.925,0,0,0,7.65,2.25,6.549,6.549,0,0,0,1.381,6.663H.368A.368.368,0,0,0,0,7.031v.912a.368.368,0,0,0,.368.368h.661A9.1,9.1,0,0,0,1.023,9.6H.368A.368.368,0,0,0,0,9.973v.869a.368.368,0,0,0,.368.368h.923a6.42,6.42,0,0,0,6.36,4.77,7.644,7.644,0,0,0,1.872-.239.368.368,0,0,0,.269-.428l-.27-1.363Z",
    transform: "translate(10.025 5.885)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvesteringWhite);
export default __webpack_public_path__ + "static/media/investering-white.f89ad53ac1da90f50cec23192fe1ee64.svg";
export { ForwardRef as ReactComponent };